<!--<mat-toolbar>-->
<div class="filtros-interno">
  <form [formGroup]="filtrosForm">
    <ng-container *ngIf="showBulkActions">
      <div class="bulk-actions--small">
        <button style="width: 90%; margin-bottom: 4px;" mat-raised-button color="primary"
          (click)="limpiarConexiones()"
          i18n="botón limpiar conexiones | botón limpiar conexiones@@btnLimpiarConexiones">Limpiar conexiones
        </button>
        <button style="width: 90%;" mat-button (click)="showConnectedOnly.emit()"
          i18n="ver conexiones | ver conexiones@@btnVerConexiones">
          <span *ngIf="activeConnections; else verConectadas">Ver todo</span>
          <ng-template #verConectadas>Ver solo conectadas</ng-template>
        </button>
      </div>
    </ng-container>
    <div>
      <ul>
        <li>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Unidades por año</mat-label>
            <mat-select placeholder="Años"  multiple>
              <mat-option (onSelectionChange)="unitsByYear.emit({checked: $event.source._selected, periodo: periodo})" *ngFor="let periodo of periodos" [value]="periodo">
                {{periodo.nombre}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </li>
        <h4 class="mat-h4">Tipos de metas</h4>
        <li *ngFor="let goalCategory of goalsCategories">
          <mat-checkbox color="primary" [value]="goalCategory" *ngIf="goalCategory.ordenAgrupador <= 2"
            (change)="columnSelect(goalCategory.ordenAgrupador, $event.checked)"
            [checked]="goalCategory.ordenAgrupador === 4">{{goalCategory.nombre}}</mat-checkbox>
            <mat-checkbox color="primary" [value]="goalCategory" *ngIf="goalCategory.ordenAgrupador > 2"
            (change)="columnSelect(goalCategory.ordenAgrupador, $event.checked)"
            [checked]="goalCategory.ordenAgrupador === 4">{{goalCategory.agrupador}}</mat-checkbox>
        </li>
        <li>
        <h4 class="mat-h4"></h4>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Mostrar detalles</mat-label>
            <mat-select placeholder="Mostrar detalles" formControlName="detalles" multiple>
              <mat-option [value]="'fullHtml'">Descripción completa</mat-option>
              <mat-option [value]="'areas'">Materias</mat-option>
              <mat-option [value]="'cursos'">Cursos</mat-option>
              <mat-option [value]="'ambitos'">Ámbitos</mat-option>
              <mat-option [value]="'tags'">Etiquetas</mat-option>
            </mat-select>
          </mat-form-field>
        </li>
      </ul>
    </div>
    <h4 class="mat-h4">Filtrar por:</h4>
    <div formGroupName="nested">
      <div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Palabra en descripción</mat-label>
          <input matInput placeholder="Palabra en descripción" formControlName="descripcion">
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Materias</mat-label>
          <mat-select placeholder="Materias" formControlName="areas" multiple>
            <mat-optgroup *ngFor="let area of areas" [label]="area.nombre">
              <mat-option *ngFor="let materia of area.materias" [value]="materia.id.toString()">
                {{materia.nombre}} <span class="font-sub2">({{area.nickName}})</span>
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Cursos</mat-label>
          <mat-select placeholder="Grados" formControlName="cursos" multiple>
            <mat-option *ngFor="let curso of cursos" [value]="curso.id.toString()">{{curso.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Ámbitos</mat-label>
          <mat-select placeholder="Ámbitos" formControlName="ambitos" multiple>
            <mat-optgroup *ngFor="let ambito of ambitos" [label]="ambito.nombre">
              <mat-option *ngFor="let ambitoChild of ambito.categorias" [value]="ambitoChild.id.toString()">
                {{ambitoChild.nombre}}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Tags</mat-label>
          <mat-select placeholder="Tags" formControlName="tags" multiple>
            <mat-option *ngFor="let tag of tags" [value]="tag.id.toString()">{{tag.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>

  <button mat-raised-button color="primary" class="hide-show-opt" (click)="hideMe.next(false)">
    Cerrar
  </button>
</div>
<!--</mat-toolbar>-->
